import { h, Host } from "@stencil/core";
import localI18n from "../../util/i18n";
import { getShouldBeIgnored } from "../../util/jwt-util/html-util/html-util";
import { JwtUtil } from "../../util/jwt-util/jwt-util";
import { getIconByStorklevel } from "../../util/stork-icon-util";
export class AuthnLevelShield {
    constructor() {
        this.authnLevel = undefined;
        this.showMenuButton = false;
        this.showFlyout = false;
        this.isInvisible = false;
    }
    el;
    jwt;
    /**
     * Request a token event form the oiam-oauth-wc
     */
    sendTokenEventEmitter;
    closeFlyoutWhenTabbingOut(event) {
        if (event.key !== 'Tab') {
            return;
        }
        const path = event.composedPath();
        const flyout = this.el.shadowRoot.getElementById('headerFlyoutShield');
        if (!path.includes(flyout) && this.showFlyout) {
            this.hideFlyout();
        }
    }
    handleTokenEvent(ev) {
        const jwtValidationResult = JwtUtil.validateJwt(ev);
        if (jwtValidationResult.isValidJwt) {
            this.jwt = jwtValidationResult.jwt;
            let level = this.jwt.payload['authn-level'];
            if (JwtUtil.isValidAuthnLevel(level)) {
                this.authnLevel = level;
                this.showMenuButton = true;
            }
        }
        else {
            // we have to hide the component if there is an empty jwt (logout in other tab, browser back etc.)
            if (this.showFlyout) {
                this.hideFlyout();
            }
            this.showMenuButton = false;
        }
    }
    componentDidLoad() {
        this.sendTokenEventEmitter.emit();
    }
    render() {
        if (this.showMenuButton && !this.isInvisible) {
            return (h(Host, { key: '227af0c3206fea75feecba158531626a099e13cb', class: 'd-block rounded' }, h("div", { key: 'e41f514792dc9059100b51d95add0cdf00e8b539', class: "ba-header-element" }, this.getShield(), this.getFlyOut())));
        }
    }
    getShield() {
        return (h("button", { id: "session-shield-button", class: `${getIconByStorklevel(this.authnLevel)} ba-menu-entry ba-trust collapsed`, title: localI18n.t('AKTUELLE_ANMELDEOPTION'), type: "button", "data-bs-toggle": "collapse", onClick: () => this.onButtonClick(), "data-bs-target": "#headerFlyoutShield", "aria-expanded": "false", "aria-controls": "headerFlyoutShield" }));
    }
    getFlyOut() {
        return (h("div", { class: "ba-flyout-container ba-flyout-trust" }, h("div", { id: "headerFlyoutShield", class: "ba-flyout-collapse collapse", "data-parent": ".ba-header" }, h("div", { class: "ba-flyout ba-menu-container", "aria-label": localI18n.t('VERTRAUENSNIVEAU'), style: { maxHeight: '764px' } }, h("h2", { id: "headingTrustLevel" }, localI18n.t('AKTUELLE_ANMELDEOPTION')), h("hr", { "aria-hidden": "true" }), this.getShieldIcons(), this.getText(), this.getInfobox()))));
    }
    getShieldIcons() {
        return (h("div", { class: "ba-trust-level" }, h("auth-level-with-status", { storkLevel: 'STORK-QAA-Level-1', status: this.authnLevel === 'STORK-QAA-Level-1' || this.authnLevel === 'STORK-QAA-Level-2' ? 'current' : 'inactive', "data-testid": 'shield-basis' }), h("auth-level-with-status", { storkLevel: 'STORK-QAA-Level-3', status: this.authnLevel === 'STORK-QAA-Level-3' ? 'current' : 'inactive', "data-testid": 'shield-substanziell' }), h("auth-level-with-status", { storkLevel: 'STORK-QAA-Level-4', status: this.authnLevel === 'STORK-QAA-Level-4' ? 'current' : 'inactive', "data-testid": 'shield-hoch' })));
    }
    getText() {
        if (this.authnLevel === 'STORK-QAA-Level-1') {
            return (h("p", { "data-testid": 'text-basis' }, localI18n.t('TEXT_LEVEL_1_1'), h("strong", null, localI18n.t('TEXT_LEVEL_1_2')), localI18n.t('TEXT_LEVEL_1_3')));
        }
        if (this.authnLevel === 'STORK-QAA-Level-3') {
            return (h("p", { "data-testid": 'text-substanziell' }, localI18n.t('TEXT_LEVEL_3_1'), h("strong", null, localI18n.t('TEXT_LEVEL_3_2')), localI18n.t('TEXT_LEVEL_3_3')));
        }
        if (this.authnLevel === 'STORK-QAA-Level-4') {
            return (h("p", { "data-testid": 'text-hoch' }, localI18n.t('TEXT_LEVEL_4_1'), h("strong", null, localI18n.t('TEXT_LEVEL_4_2')), localI18n.t('TEXT_LEVEL_4_3')));
        }
    }
    getInfobox() {
        if (this.authnLevel === 'STORK-QAA-Level-1') {
            return (h("p", { class: "ba-accent ba-accent-important mb-0", id: "shieldInfo" }, localI18n.t('INFOBOX_LEVEL_1_1'), h("i", { class: 'ba-icon ba-icon-trust-high d-inline ms-1 py-0 pe-0', role: "img", "aria-label": localI18n.t('INFOBOX_ICON_TITLE_HIGHT') }), localI18n.t('INFOBOX_LEVEL_1_2'), h("i", { class: 'ba-icon ba-icon-trust-medium d-inline ms-1 py-0 pe-0', role: "img", "aria-label": localI18n.t('INFOBOX_ICON_TITLE_MEDIUM') }), localI18n.t('INFOBOX_LEVEL_1_3'), h("a", { href: 'https://www.arbeitsagentur.de/bundid-sicherer-zugang-zu-allen-eservices', class: 'ba-textlink' }, localI18n.t('INFOBOX_LEVEL_1_4'))));
        }
        if (this.authnLevel === 'STORK-QAA-Level-3') {
            return (h("p", { class: "ba-accent ba-accent-important mb-0", id: "shieldInfo" }, localI18n.t('INFOBOX_LEVEL_3_1'), h("i", { class: 'ba-icon ba-icon-trust-high d-inline ms-1 py-0 pe-0', role: "img", "aria-label": localI18n.t('INFOBOX_ICON_TITLE_HIGHT') }), localI18n.t('INFOBOX_LEVEL_3_2'), h("a", { href: 'https://www.arbeitsagentur.de/bundid-sicherer-zugang-zu-allen-eservices', class: 'ba-textlink' }, localI18n.t('INFOBOX_LEVEL_3_3'))));
        }
        if (this.authnLevel === 'STORK-QAA-Level-4') {
            return (h("p", { class: "ba-accent ba-accent-important mb-0", id: "shieldInfo" }, localI18n.t('INFOBOX_LEVEL_4_1')));
        }
    }
    onButtonClick() {
        this.toggleFlyout();
    }
    toggleFlyout() {
        if (this.showFlyout) {
            this.hideFlyout();
        }
        else {
            this.showFlyoutContent();
        }
    }
    handleClickEvent(event) {
        const path = event.composedPath();
        // This solves a bug. Other Teams are closing their flyouts by creating an additional click on their menu-items.
        // We need to ignore these additional Clicks. Otherwise, our flyout opens and then instantly closes.
        const shouldBeIgnored = getShouldBeIgnored(path);
        if (shouldBeIgnored) {
            return;
        }
        if (!path.includes(this.el) && this.showFlyout) {
            this.hideFlyout();
        }
    }
    handleKeyDown(ev) {
        if (ev.key === 'Escape' && this.showFlyout) {
            this.hideFlyout();
        }
    }
    showFlyoutContent() {
        const flyout = this.el.shadowRoot.querySelector('#headerFlyoutShield');
        const button = this.el.shadowRoot.querySelector('#session-shield-button');
        flyout.classList.add('collapsed');
        flyout.classList.remove('collapse');
        button.classList.add('collapse');
        button.classList.remove('collapsed');
        button.ariaExpanded = 'true';
        this.showFlyout = !this.showFlyout;
    }
    hideFlyout() {
        const flyout = this.el.shadowRoot.querySelector('#headerFlyoutShield');
        const button = this.el.shadowRoot.querySelector('#session-shield-button');
        flyout.classList.remove('collapsed');
        flyout.classList.add('collapse');
        button.classList.add('collapsed');
        button.classList.remove('collapse');
        button.ariaExpanded = 'false';
        this.showFlyout = !this.showFlyout;
    }
    static get is() { return "authn-level-shield"; }
    static get encapsulation() { return "shadow"; }
    static get originalStyleUrls() {
        return {
            "$": ["authn-level-shield.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["authn-level-shield.css"]
        };
    }
    static get properties() {
        return {
            "isInvisible": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": "\uD83E\uDDD9\u200D\u2642\uFE0F Guard for rendering. UseCase no visibleHeader is present, but all should work."
                },
                "attribute": "is-invisible",
                "reflect": false,
                "defaultValue": "false"
            }
        };
    }
    static get states() {
        return {
            "authnLevel": {},
            "showMenuButton": {},
            "showFlyout": {}
        };
    }
    static get events() {
        return [{
                "method": "sendTokenEventEmitter",
                "name": "oiamSendTokenEvent",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": "Request a token event form the oiam-oauth-wc"
                },
                "complexType": {
                    "original": "void",
                    "resolved": "void",
                    "references": {}
                }
            }];
    }
    static get elementRef() { return "el"; }
    static get listeners() {
        return [{
                "name": "keyup",
                "method": "closeFlyoutWhenTabbingOut",
                "target": "window",
                "capture": false,
                "passive": false
            }, {
                "name": "oiamTokenEvent",
                "method": "handleTokenEvent",
                "target": "window",
                "capture": false,
                "passive": false
            }, {
                "name": "click",
                "method": "handleClickEvent",
                "target": "window",
                "capture": false,
                "passive": false
            }, {
                "name": "keydown",
                "method": "handleKeyDown",
                "target": "window",
                "capture": false,
                "passive": false
            }];
    }
}
